/**
 * When a signed-out visitor is asked to create an account.
 *
 * The rule is one sentence — sign-up is asked for at the first step that needs
 * the booking to belong to someone — but it is applied from three components, so
 * it lives here rather than being restated (and drifting) in each of them.
 */
export type SignupPromptTrigger = "addToCart" | "bookNow" | "cartCheckout";

interface ISignupPromptState {
    isLoggedIn: boolean;
    /** Whether the offer has already been accepted this session. */
    promptSeen: boolean;
}

export const shouldPromptSignup = (
    trigger: SignupPromptTrigger,
    { isLoggedIn, promptSeen }: ISignupPromptState,
): boolean => {
    if (isLoggedIn || promptSeen) return false;

    // Adding to the cart commits to nothing: a guest fills a cart, comes back,
    // edits it and removes things, all signed out. Book Now and the cart's
    // Checkout button both open the checkout itself, which is where an account
    // becomes necessary.
    return trigger !== "addToCart";
};
